import { inject } from '@angular/core'
import { Router, CanActivateFn, UrlTree } from '@angular/router'
import { Observable, of } from 'rxjs'
import {
  map,
  catchError,
  timeout,
  take,
  switchMap,
  filter
} from 'rxjs/operators'
import { AuthServiceGeneric } from './auth.service'
import { Store } from '@ngrx/store'
import { selectIsAuthenticated } from './auth.selectors'

export const authGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router)
  const auth = inject(AuthServiceGeneric)
  const store = inject(Store)

  // ✅ Check store first (catches the moment right after login before localStorage flush)
  return store.select(selectIsAuthenticated).pipe(
    take(1),
    switchMap((isAuthenticated) => {
      if (isAuthenticated) return of(true)

      // Fallback: check localStorage
      const authData = localStorage.getItem('ANMS-AUTH')
      if (authData) return of(true)

      // Last resort: silent token
      return auth.getAccessTokenSilently().pipe(
        timeout(3000),
        map((token) => {
          if (token) return true as boolean | UrlTree
          localStorage.removeItem('ANMS-AUTH')
          return router.parseUrl('/login')
        }),
        catchError(() => {
          localStorage.removeItem('ANMS-AUTH')
          return of(router.parseUrl('/login'))
        })
      )
    })
  )
}
